import axios from 'axios';

export const API_SERVER_HOST = process.env.REACT_APP_API_SERVER_HOST || '/api';

const http = axios.create({ baseURL: API_SERVER_HOST });

export const getItems = (response) => response.data.items || [];

export const findInfoValue = (items, infoKey, fallback = '') =>
  items.find((item) => item.info_key === infoKey)?.info_value || fallback;

export const getInformation = () => http.get('/information');
export const getHistories = (sectionCode) =>
  http.get('/histories', { params: sectionCode ? { section: sectionCode } : {} });
export const getVisions = () => http.get('/visions');
export const getBusinessAreas = () => http.get('/business-areas');
export const getBusinessAreaBySlug = (slug) => http.get(`/business-areas/${slug}`);
export const getBusinessClients = () => http.get('/business-clients');
export const getDownloadCategories = () => http.get('/downloads/categories');
export const getDownloads = (categoryCode) =>
  http.get('/downloads', { params: categoryCode ? { category: categoryCode } : {} });
export const downloadFileById = (downloadId) =>
  http.get(`/downloads/${downloadId}/file`, { responseType: 'blob' });
